import { MODULE_NAME } from './constants'

export const STATUS_SET_ITEM = `${MODULE_NAME}/STATUS_SET_ITEM`
